import { render } from "./Cashboxes.vue?vue&type=template&id=fa11a2ca&scoped=true"
import script from "./Cashboxes.vue?vue&type=script&lang=js"
export * from "./Cashboxes.vue?vue&type=script&lang=js"

import "./Cashboxes.vue?vue&type=style&index=0&id=fa11a2ca&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa11a2ca"]])

export default __exports__